import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Language from '../domain/Language';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import Thumb from './common/Thumb';
import { useTranslation } from 'react-i18next';

const RankingRecordImage = (props) => {
    const {t,i18n} = useTranslation()
    let type = ""
    if(props.data.type === 1){
        type = t("common.s_all")
    } else if(props.data.type === 2){
        type = t("common.s_odai")
    } else if(props.data.type === 3){
        type = t("common.s_jogai")
    }
    return (<Row style={{border:"1px solid #555555",borderRadius:"5px",width:"100%"}} className="mb-3 lazy" key={props.i}>
                <Col className='p-0 m-0'><Thumb data={props.data} dataType={props.dataType} i={props.i} dialog={props.dialog} observer={props.observer} /></Col>
                <Col className='p-0 m-0'>
                    <span style={{fontWeight:"bold",fontSize:"28px"}}><RIcon.FaCrown style={{width:"28px",color:"orange"}}/> {props.data.rank}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}>{props.data.title}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}>{t("common.date")}：<br />&nbsp;&nbsp;&nbsp;{props.data.ymd}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}>{t("common.postDatetime")}:<br />&nbsp;&nbsp;&nbsp;{props.data.booking_datetime === '0000-00-00 00:00:00' ? props.data.create_datetime : props.data.booking_datetime}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}>{type}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}><Icon.Eye />：{props.data.total_pv}</span><br />
                    <span style={{fontWeight:"bold",fontSize:"18px"}}><Icon.HandThumbsUp />：{props.data.favorite_count}</span><br />
                </Col>
            </Row>

    )
}

export default RankingRecordImage;
